"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseBetweenCondition = void 0;
const has_js_1 = require("../../../../../utils/has.js");
const parseBetweenCondition = (conditionParser, condition) => {
    var _a;
    let attributePath;
    let transform;
    const size = (0, has_js_1.has)(condition, 'size');
    if (size) {
        attributePath = condition.size;
        transform = false;
    }
    else {
        attributePath = condition.attr;
        transform = (_a = condition.transform) !== null && _a !== void 0 ? _a : true;
    }
    const [lowerRange, higherRange] = condition.between;
    conditionParser.resetExpression();
    const attribute = conditionParser.appendAttributePath(attributePath, { size });
    conditionParser.appendToExpression(' BETWEEN ');
    conditionParser.appendAttributeValueOrPath(attribute, lowerRange, { transform });
    conditionParser.appendToExpression(' AND ');
    conditionParser.appendAttributeValueOrPath(attribute, higherRange, { transform });
};
exports.parseBetweenCondition = parseBetweenCondition;
